
<template>
   <atom-text
      size="x-large"
      :color="color"
      :text="title"
      style="font-weight: 600; text-align: center;"
   />
</template>

<script>
import AtomText from '../Text';


export default {
   name: 'Title',
   components: {
      AtomText,
   },
   props: {
      title: {
         type: String,
         required: true,
      },
      color: {
         type: String,
         default: 'secondary',
         validator: value => ["primary","secondary","success","info","light","dark", "danger"].includes(value),
      },
   }
}
</script>

<style>
</style>